module.exports = __webpack_public_path__ + "static/media/la.b76f93a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/la.svg
// module id = 171
// module chunks = 0